import React, {useEffect} from 'react'
import './AutoClose.scss'
import { useIntl } from 'react-intl'
import { FormBase, SchedulingForm } from '@/app/models/new-activity-form'
import {LuxSelect} from "@lux/wardrobe-lib";

const optionsList = () => {
    const value = []
    for (let i = 0; i <= 30; i++) {
        value.push(i)
    }
    return value
}

const AutoClose = (props: FormBase<SchedulingForm>) => {
    const componentClass = 'smart-new-activity-scheduling-auto-close'
    const { form, onSetForm } = props
    const intl = useIntl()

    useEffect(() => {
        onSetForm({
            ...form,
            autoCloseDays: {
                ...form.autoCloseDays,
                value: form.autoCloseDays.value ?? 15,
            },
            autoClose: { value: true },
        })
    }, [])

    return (
        <>
            <div className={`${componentClass}__radio-auto-close-content`}>
                <div className={`${componentClass}__radio-auto-close-content__select`}>
                    <LuxSelect
                        label={intl.formatMessage({
                            id: `modals.new.activity.section.scheduling.auto.close`,
                            defaultMessage: 'Auto close',
                        })}
                        mandatory={true}
                        value={form.autoCloseDays.value}
                        disabled={form.autoCloseDays.disabled}
                        onChangeCallback={(value) =>
                            onSetForm({ ...form, autoCloseDays: { ...form.autoCloseDays, value } })
                        }
                        additionalProps={{
                            appendTo: 'self',
                        }}
                        classes={'dropdown-auto-close'}
                        options={optionsList()}
                        valueTemplate={(value) => {
                            return value?.toString()
                        }}
                    />
                </div>
                <span className="text auto-close-text">
                    {intl.formatMessage({
                        id: `modals.new.activity.section.scheduling.auto.close.days.select`,
                        defaultMessage: 'days after',
                    })}
                </span>
            </div>
        </>
    )
}

export default AutoClose
